import { render } from "./MessageDialog.vue?vue&type=template&id=73e7eae8&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"

import "./MessageDialog.vue?vue&type=style&index=0&id=73e7eae8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73e7eae8"

export default script